document.addEventListener('DOMContentLoaded', () => {
  const PASS_SELECTORS = {
    container: '.coming-soon',
    password_input_id: 'coming_password',
    password_submit: '.password_submit',
    countdown: ".coming-soon__counter"
  };
  let passwordToSave = '';

  const container = document.querySelector(PASS_SELECTORS.container);
  if (!container) return;

  const submit = container.querySelector(PASS_SELECTORS.password_submit);
  const passwordInput = document.getElementById(PASS_SELECTORS.password_input_id);
  if (!submit || !passwordInput) return;

  const dataPassword = container.dataset ? container.dataset.pass : null;

  if (dataPassword) {
    const handleizePass = dataPassword.toLowerCase().replaceAll(' ', '-');
    if (location.search.includes(handleizePass)) {
      passwordToSave = dataPassword;
      removeComingSoonLayer();
    }
  }

  submit.addEventListener('click', () => {
    if (dataPassword === passwordInput.value) {
      passwordToSave = dataPassword;
      removeComingSoonLayer();
    }
  });

  function removeComingSoonLayer() {
    if (!passwordToSave) return;

    const countdown = document.querySelector(PASS_SELECTORS.countdown);
    let date;

    if (countdown && countdown.dataset.date) {
      date = new Date(countdown.dataset.date);
    } else {
      date = new Date();
      date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
    }

    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `comingSoonHide=${passwordToSave};${expires};path=/`;

    container.remove();
    document.body.style.overflow = 'auto';
  }
});
